var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(false)?_c('van-nav-bar',{staticStyle:{"background":"#f5f5f5","padding-top":"25px"},attrs:{"title":"详情","left-arrow":""},on:{"click-left":function($event){return _vm.$router.go(-1)}}}):_vm._e(),_c('van-image',{staticStyle:{"width":"100%"},attrs:{"src":require('/static/img/news_detail.png')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }